export default __webpack_public_path__ + "static/DINosaurKU-Light-ec0e9cf3af9edbbb539cef8950614980.woff";